import React from "react";
import Chip from "@material-ui/core/Chip";
import Tooltip from "@material-ui/core/Tooltip";
import { STATUS_COLORS } from "./constants";
import { i18n } from "../../translate/i18n";

export default function AppointmentStatusBadge({ status }) {
  const label = i18n.t(`appointmentsModule.status.${status}`, { defaultValue: status });
  const color = STATUS_COLORS[status] || "#757575";
  return (
    <Tooltip title={label}>
      <Chip
        size="small"
        label={label}
        style={{ backgroundColor: color, color: "#fff" }}
      />
    </Tooltip>
  );
}
